import type { ValidationConfig } from '../validationEngine/types';

export const CANCELLATION_DAYS_MAX = 99;
export const CANCELLATION_CHARGE_MAX = 999999.99;
const INLINE_AND_CONTRACT_FLOW = 'default+contract';

export const cancellationTermsValidationConfig: ValidationConfig = {
    rightToCancelDays: {
        rules: [
            {
                type: 'CUSTOM',
                flow: INLINE_AND_CONTRACT_FLOW,
                params: {
                    evaluator: (v: unknown) => {
                        if (v === undefined || v === null || v === '') return true;
                        const n = Number(v);
                        return !isNaN(n) && n >= 0 && n <= CANCELLATION_DAYS_MAX;
                    }
                },
                messages: {
                    inline: 'Cancellation Days must be between 0 and 99.',
                    gcalert: 'Cancellation Days must be between 0 and 99.'
                }
            },
            {
                type: 'REQUIRED',
                flow: INLINE_AND_CONTRACT_FLOW,
                messages: {
                    inline: 'Cancellation Days is required when Cancellation Charge is provided.',
                    gcalert: 'Cancellation Days is required when Cancellation Charge is provided.'
                },
                conditions: {
                    when: (_ctx, _value, scope) => {
                        const details = scope as { rightToCancelCharge?: number | null | string };
                        const charge = details?.rightToCancelCharge;
                        return charge != null && charge !== '';
                    }
                }
            }
        ]
    },
    rightToCancelCharge: {
        rules: [
            {
                type: 'CUSTOM',
                flow: INLINE_AND_CONTRACT_FLOW,
                params: {
                    evaluator: (v: unknown) => {
                        if (v === undefined || v === null || v === '') return true;
                        const n = Number(v);
                        return !isNaN(n) && n >= 0 && n <= CANCELLATION_CHARGE_MAX;
                    }
                },
                messages: {
                    inline: 'Cancellation Charge must be between 0 and 999,999.99.',
                    gcalert: 'Cancellation Charge must be between 0 and 999,999.99.'
                }
            },
            {
                type: 'REQUIRED',
                flow: INLINE_AND_CONTRACT_FLOW,
                messages: {
                    inline: 'Cancellation Charge is required when Cancellation Days is provided.',
                    gcalert: 'Cancellation Charge is required when Cancellation Days is provided.'
                },
                conditions: {
                    when: (_ctx, _value, scope) => {
                        const details = scope as { rightToCancelDays?: number | null | string };
                        const days = details?.rightToCancelDays;
                        return days != null && days !== '';
                    }
                }
            }
        ]
    }
};
